import React from 'react';
import { Box, Typography } from '@mui/material';

import { buildAppointmentNotificationSummary } from '../../../utils/appointmentNotificationSummary';

const singleLineSx = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const AppointmentNotificationDetails = ({
  data,
  locale,
  audience = 'professional',
  fallbackDate,
  fallbackMessage,
}) => {
  const summary = buildAppointmentNotificationSummary(data, locale, audience);

  if (!summary) {
    return (
      <>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ ...singleLineSx, mb: 0.5 }}
        >
          {fallbackDate}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
        >
          {fallbackMessage}
        </Typography>
      </>
    );
  }

  return (
    <Box sx={{ display: 'grid', gap: 0.25 }}>
      {summary.contextLine && (
        <Typography
          variant="body2"
          color="text.primary"
          sx={{ ...singleLineSx, fontWeight: 600 }}
        >
          {summary.contextLine}
        </Typography>
      )}
      {summary.scheduleLine && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={singleLineSx}
        >
          {summary.scheduleLine}
        </Typography>
      )}
    </Box>
  );
};

export default AppointmentNotificationDetails;
